import { homeSeoContent } from '@/mocks/seoContent';

export default function TrustBar() {
  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 bg-accent-100/80 px-3 py-1.5 rounded-full mb-4">
              {homeSeoContent.trustSectionTagline}
            </span>
            <p className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed italic">
              {homeSeoContent.trustSectionDescription}
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                Editorial Team Verified
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                Updated June 2026
              </span>
              <span className="flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                Content Reviewed Regularly
              </span>
            </div>
          </div>

          <div className="lg:w-3/5">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
              {homeSeoContent.trustStats.map((stat, idx) => (
                <div key={idx} className="group">
                  <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-100 mb-3">
                    <img
                      src={stat.image}
                      alt={stat.label}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <p className="font-heading text-3xl md:text-4xl text-foreground-900 mb-1">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-500 font-medium tracking-wide">
                    {stat.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}